import React, { Component } from "react";
import styled from "styled-components";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";

import { BlockLoader, Static } from "../components";
import { SiteTemplate } from "../components/Site";

import { Row, Col } from "reactstrap";

import { get } from "../applications/actions";

import { format } from "date-fns";
import { replacePlaceholders } from "../lib/utils";
import routes from "../routes";

class Single extends Component {
  componentDidMount = async () => {
    const { match, get, history } = this.props;

    const uid = match.params.uid;
    try {
      await get(uid);
    } catch ({ response }) {
      if (response.status === 404) {
        history.replace("/404");
      }
    }
  };

  render() {
    const { match, applications } = this.props;

    const uid = match.params.uid;
    const item = applications.get(uid);

    return (
      <SiteTemplate title="Aplikacje">
        <BlockLoader isLoading={!item}>
          {item && (
            <StyledRow>
              <Col xs="6">
                <Static label="Oferta">
                  <Link
                    to={replacePlaceholders(routes.offersEdit, {
                      uid: item.get("offerUID")
                    })}
                  >
                    Przejdź do oferty
                  </Link>
                </Static>
                <Static label="Imię">{item.get("firstName")}</Static>
                <Static label="Nazwisko">{item.get("lastName")}</Static>
                <Static label="Email">{item.get("email")}</Static>
                <Static label="Telefon">{item.get("phoneNumber")}</Static>
                <Static label="Utworzono">
                  {format(item.get("createdAt"), "HH:mm DD.MM.YYYYr.")}
                </Static>
              </Col>
            </StyledRow>
          )}
        </BlockLoader>
      </SiteTemplate>
    );
  }
}

const StyledRow = styled(Row)`padding: 20px;`;

Single = connect(
  state => ({
    applications: state.entities.get("applications")
  }),
  {
    get
  }
)(Single);

Single = withRouter(Single);

export default Single;



// WEBPACK FOOTER //
// ./src/applications/Single.js